import React, { useState, useEffect, useCallback, useMemo } from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import { useBreakWorkHub } from "../../services/breakWork.service.v2";
import { useAgentWorkspaceHubContext } from "../../contexts/AgentWorkspaceHubContext";
import { GlobalTimerProvider } from "../../contexts/GlobalTimerContext";

import Api from "../../services/api";
import * as Service from '../../services/techinicalteamorganizationcategory.service';

import { getOrganizations } from "src/services/called.service";

import clsx from "clsx";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  CircularProgress,
  Container,
  CssBaseline,
  Grid,
  Tooltip,
} from "@mui/material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { withStyles } from "@mui/styles";

import { Overlay } from "../../styles/global";
import { Styles } from "../../styles/material-styles";

import Footer from "../../components/footer";
import HeaderMenu from "../../components/header-menu";
import CustomizedSnackbars from "../../components/material-snackbars";
import BreakWorkBasicTable from '../../components/break-reason/break-work-basic-table';
import SimpleAutoCompleteMultiple from "../../components/auto-complete/autocomplete-multiple-create";
import RealSimpleAutoComplete from "../../components/auto-complete/autocomplete-with-onclick";

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const initialState = {
  openNotification: false,
  notificationVariant: "error",
  notificationMessage: "",
  isGlobalADM: false,
  orgsList: [],
  loadingOrgsList: false,
  orgsSelected: [],
  techinicalTeamList: [],
  techinicalTeamSelected: [],
  localLoading: false, // Loading para operações locais (não do hook)
};

const BreakWorkCollaboratorsActive = ({ classes }) => {
  const intl = useIntl();
  const { lang } = useParams();

  const [state, setState] = useState(initialState);

  const updateState = useCallback((updatesOrFn) => {
    setState((prev) => {
      const updates = typeof updatesOrFn === 'function'
        ? updatesOrFn(prev)
        : updatesOrFn;
      return { ...prev, ...updates };
    });
  }, []);

  const headerMenu = useSelector((state) => state.headerMenu);
  const actionsHeaderMenu = useSelector((state) => state.actionsHeaderMenu);
  const userSession = useSelector((state) => state.userSession);

  // IDs dos times para filtro
  const { teamIdsArray, teamIdsQuery } = useMemo(() => {
    if (!Array.isArray(state.techinicalTeamSelected) || state.techinicalTeamSelected.length === 0) {
      return { teamIdsArray: null, teamIdsQuery: null };
    }
    const ids = state.techinicalTeamSelected.map(t => t?.id).filter(Boolean);
    return {
      teamIdsArray: ids.length > 0 ? ids : null,
      teamIdsQuery: ids.length > 0 ? ids.join(',') : null
    };
  }, [state.techinicalTeamSelected]);

  const { agentWorkspaceHub } = useAgentWorkspaceHubContext();
  
  // Hook retorna dados diretamente - não precisa de updateState para breaks
  const { 
    activeBreaks, 
    loading: breaksLoading, 
    connected,
    notification: hookNotification,
    clearNotification: clearHookNotification
  } = useBreakWorkHub(agentWorkspaceHub, intl, teamIdsQuery, teamIdsArray);

  // Combina loading local com loading do hook
  const loading = state.localLoading || breaksLoading;

  const handleGetOrganizations = async () => {
    try {
      if (state.loadingOrgsList || state.orgsList.length > 0) return;

      updateState({ loadingOrgsList: true });

      if (
        userSession
        && userSession.user
        && userSession.user.userorganizations
        && userSession.user.userorganizations.length > 0
      ) {

        updateState({ orgsList: userSession.user.userorganizations });
        return;
      } else {
        const result = await getOrganizations();

        if (result.success) {
          updateState({ orgsList: result.data });
        } else {
          updateState({
            openNotification: true,
            notificationVariant: 'error',
            notificationMessage: result.response && result.response.data && result.response.data.errors && result.response.data.errors[0] ? result.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
          });
          Api.kickoff(result);
        }
      }
    } catch (err) {
      updateState({
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: err.response && err.response.data && err.response.data.errors && err.response.data.errors[0] ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
      });
      Api.kickoff(err);
    } finally {
      updateState({ loadingOrgsList: false });
    }
  }

  const getTechinicalTeamsByOrganizations = async (orgIds) => {
    try {
      var orgs = ""
      if (orgIds != null && orgIds.length > 0) {
        let ids = orgIds.map(c => c.id);
        orgs = ids.join(',');
      }

      updateState({ localLoading: true });

      var result = await Service.getTechinicalTeamsByOrganizationIds(orgs);

      if (result.success) {
        updateState({ techinicalTeamList: result.data, localLoading: false });
      } else {
        updateState({
          localLoading: false,
          openNotification: true,
          notificationVariant: 'error',
          notificationMessage: result.response && result.response.data && result.response.data.errors && result.response.data.errors[0] ? result.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
        });
        Api.kickoff(result);
      }
    } catch (err) {
      updateState({
        localLoading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: err.response && err.response.data && err.response.data.errors && err.response.data.errors[0] ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
      });
      Api.kickoff(err);
    }
  }

  const removeDuplicateIds = (array, idKey = 'id') => {
    if (!Array.isArray(array) || array.length === 0) return [];
    
    const seen = new Set();
    return array.filter(item => {
      const id = item?.[idKey];
      if (id == null) return false;
      const key = String(id);
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  }

  const closeNotification = useCallback(() => {
    updateState({ openNotification: false });
  }, [updateState]);

  const changeValues = async (stateName, value, text = '') => {
    const shouldControlLoading = stateName === 'orgsSelected';

    if (shouldControlLoading) {
      updateState({ localLoading: true });
    }

    if (stateName === 'orgsSelected') {
      if (value == null || (value != null && value.length == 0)) {
        updateState({
          techinicalTeamList: [],
          techinicalTeamSelected: [],
        });
      }
      else {
        if (value.length < state.orgsSelected.length) {
          updateState({ techinicalTeamSelected: [] });
        }

        await getTechinicalTeamsByOrganizations(value);
      }

      updateState({ [stateName]: value });
    } else if (stateName === 'techinicalTeamSelected') {
      updateState({ [stateName]: removeDuplicateIds(value || []) });
    } else {
      updateState({ [stateName]: value });
    }

    if (shouldControlLoading) {
      updateState({ localLoading: false });
    }
  };

  // Mostra notificação do hook quando houver
  useEffect(() => {
    if (hookNotification) {
      updateState({
        openNotification: true,
        notificationVariant: hookNotification.variant,
        notificationMessage: hookNotification.message
      });
      clearHookNotification();
    }
  }, [hookNotification, clearHookNotification, updateState]);

  useEffect(() => {
    if (userSession == null || userSession.user == null || userSession.user.userrole == null) {
      Api.logoff();
    }
  }, [userSession]);

  if (Api == null) {
    document.location.href = `/${lang}/unavailable`;
    return null;
  }

  return (
    <GlobalTimerProvider>
      <div className={classes.root} style={{ paddingLeft: 0, marginLeft: 0 }}>
        <HeaderMenu />
        <main
          className={clsx(
            classes.content,
            {
              [classes.contentShift]: headerMenu.open,
            },
            classes.actionsContent,
            {
              [classes.actionscontentShift]: actionsHeaderMenu.open,
            }
          )}
        >
          <div className={classes.drawerHeader} />

        <Container
          component="main"
          maxWidth="xl"
          style={{ maxWidth: '100%', paddingLeft: 0, marginLeft: 0 }}
        >
          <div>
            <CssBaseline />
            <Grid container spacing={6} alignItems="center">
              <Grid item xs={12} sm={12}>
                <Card className="background-title-search">
                  <CardContent>
                    <Grid container spacing={1} alignItems="center">
                      <Grid item xs={12} sm={5} md={3} lg={6} gap={1} display="flex" alignItems="center">
                        <Typography variant="h5">
                          <FormattedMessage id="menu.breakwork.collaborators.active" />
                        </Typography>

                        <Tooltip title={connected
                          ? intl.formatMessage({ id: "menu.breakwork.collaborators.active.connected" })
                          : intl.formatMessage({ id: "menu.breakwork.collaborators.active.disconnected" })}
                        >
                          <Typography
                            component={'span'}
                            sx={{
                              display: 'block',
                              width: 10,
                              height: 10,
                              borderRadius: "50%",
                              background: connected ? "#22c55e" : "#ef4444"
                            }}
                          />
                        </Tooltip>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>

            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography className={classes.heading}>{intl.formatMessage({ id: "filters" })}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container style={{ marginBottom: 20 }} spacing={2}>
                  <Grid item xs={12} sm={6} md={4}>
                    <RealSimpleAutoComplete
                      style={{
                        background: "white",
                        fullWidth: true,
                      }}
                      label={intl.formatMessage({ id: "organization" })}
                      options={state.orgsList}
                      stateName="orgsSelected"
                      multiple
                      changeSelect={changeValues}
                      onFocus={handleGetOrganizations}
                      loading={state.loadingOrgsList}
                      selected={state.orgsSelected}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={4} >
                    <SimpleAutoCompleteMultiple
                      label={intl.formatMessage({ id: "productivity.dashboard.techinical.teams" })}
                      options={state.techinicalTeamList}
                      stateName='techinicalTeamSelected'
                      selected={state.techinicalTeamSelected}
                      changeSelect={changeValues}
                    />
                  </Grid>
                </Grid>
              </AccordionDetails>
            </Accordion>

              <BreakWorkBasicTable data={activeBreaks} />
          </div>

          {loading && (
            <Overlay>
              <CircularProgress color="secondary" />
            </Overlay>
          )}

          <CustomizedSnackbars
            variant={state.notificationVariant}
            message={state.notificationMessage}
            isOpen={state.openNotification}
            toClose={closeNotification}
          />
        </Container>
      </main>
      <Footer />
    </div>
    </GlobalTimerProvider>
  );
};

export default withStyles(Styles)(BreakWorkCollaboratorsActive);
